// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-style[data-v-4dd19b36] {\n  width: 560px;\n}\n", ""]);
// Exports
module.exports = exports;
